<!-- PlayView：2020/4/13 Vue: ^2.5.2 YuAng-->

<template>
  <div class="ts-ali-player" :class="type">
    <div class="ts-play-view" :class="type" :id="viewId"></div>
    <template v-if="!tsPlayer && !item.autoplay">
      <img class="ts-play-cover" :src="setSrc(item.coverType)" style="width: 100%;height: 100%; object-fit:fill" alt="播放器封面" />
      <div class="ts-cover-btn" @click="initPlayer()"></div>
    </template>
    <div class="ts-play-btn" :class="playing ? 'playing' : 'pause'" @click="playBtnAction()"></div>
  </div>
</template>

<script>
import { getIEVersion } from '../../utils/screen'
export default {
  name: 'PlayView',
  components: {},
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    },
    vId: {
      type: String,
      default: 'video'
    }
  },
  data() {
    return {
      tsPlayer: null,
      coverUrl: '',
      playing: true,
      firstTimePlay: true
    }
  },
  computed: {
    viewId: function () {
      let tagId = 'ali-player'
      let temId = new Date().getTime()
      return tagId + '-' + this.vId + '-' + temId
    },
    type: function () {
      let type = 'video'
      if (this.item.mediaType) {
        type = this.item.mediaType
      }
      return type
    }
  },
  created() {
    if (this.item.playCover && this.item.playCover.length > 0) {
      this.coverUrl = this.item.playCover
    } else {
      this.setDefaultCover()
    }
  },
  mounted() {
    let rawHeight = this.$el.offsetHeight
    let height = this.$el.offsetWidth * 9 / 16
    if (rawHeight < 191) { // 矫正视频最小高度
      this.$el.style.height = height + 'px'
    }
    let ieInfo = getIEVersion()
    if (ieInfo !== -1 && this.item.autoplay) {
      let reIE = new RegExp('MSIE (\\d+\\.\\d+);')
      reIE.test(navigator.userAgent)
      let fIEVersion = parseFloat(RegExp['$1'])
      this.item.autoplay = fIEVersion > 9
    }
    if (!this.item.autoplay) return
    this.initPlayer()
  },
  methods: {
    // 初始化播放器
    initPlayer: function () {
      if (this.tsPlayer) {
        this.clearPlayer()
        this.initPlayer()
      } else {
        let vm = this
        setTimeout(() => {
          try {
            vm.tsPlayer = new window.Aliplayer(vm.getOptions(), function (player) {
              vm.$emit('preview-event', { key: 'play', type: 'inited', body: player })
            })
          } catch (e) {
            console.log('播放器初始化失败:', e.message)
          }
          document.cookie = 'selectedStreamLevel=OD'
          vm.tsPlayer.on('play', function () {
            vm.playing = true
          })
          vm.tsPlayer.on('pause', function () {
            vm.playing = false
          })
          vm.tsPlayer.on('autoplay', function (e) {
            if (!e.paramData) {
              vm.playing = false
            }
          })
          vm.tsPlayer.on('requestFullScreen', function () {
            // console.log('full-screen', e)
            vm.$emit('fullScreen', true)
          })
          vm.tsPlayer.on('cancelFullScreen', function () {
            // console.log('full-screen-cancel', e)
            vm.$emit('fullScreen', false)
          })
          vm.tsPlayer.on('error', vm.errorVideo)
        }, 1)
      }
    },
    getOptions: function () {
      this.playing = true
      let options = { id: this.viewId, width: '100%', height: '100%', autoplay: this.playing, cover: this.coverUrl }
      if (this.item.encryptType) {
        options['vid'] = this.item.playId
        options['playauth'] = this.item.playAuth
        options['encryptType'] = 1 // 鉴权播放需要这个类型
        if (this.item.mediaType) {
          options['mediaType'] = this.item.mediaType
        }
      } else {
        options['source'] = this.item.url
      }
      return options
    },
    // 尝试一次纠正播放类型
    errorVideo: function (err) {
      if (err.paramData && err.paramData.error_msg.indexOf('InvalidVideo.NoneStream') !== -1) {
        this.item.mediaType = 'audio'
        this.initPlayer()
      }
    },
    clearPlayer: function () {
      // 如果播放器已经实例话过 销毁实例
      this.tsPlayer.dispose()
      // 将播放器实例重置
      this.tsPlayer = null
      // 清空播放器 DOM 内容
      let view = document.getElementById(this.viewId)
      if (view) {
        view.innerHTML = ''
      }
    },
    playBtnAction: function () {
      if (this.playing) {
        this.tsPlayer.pause()
      } else {
        this.tsPlayer.play()
      }
    },
    stopPlayer: function () {
      if (this.tsPlayer) {
        this.tsPlayer.pause()
      }
    },
    handleChange: function (value) {
      let volume = this.tsPlayer.getVolume()
      let newVolume = volume + value * 0.1
      if (newVolume > 1) {
        newVolume = 1
      } else if (newVolume < 0) {
        newVolume = 0
      }
      this.volume = '音量:' + (newVolume * 100).toFixed(0) + '%'
      this.tsPlayer.setVolume(newVolume)
    },
    setDefaultCover: function () {
      this.coverUrl = location.protocol + '//e.xkw.com/images/audio-cover.png'
    },
    setSrc: function (type) {
      if (type === 'banner') {
        return require('@/assets/images/home/video_cover.png')
      } else if (type === 'honer') {
        return this.item.playCover
      } else {
        this.setDefaultCover()
        return this.coverUrl
      }
    }
  }
}
</script>
<style scoped>
.ts-play-view {
  margin: 0 auto;
}
.ts-play-view.audio >>> .prism-cover {
  z-index: 9 !important;
}
.ts-ali-player {
  height: calc(100% - 50px) !important;
}

.ts-ali-player >>> .prism-controlbar {
  display: block;
}

.ts-ali-player >>> .outter {
  display: none;
}
</style>
